import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { EmbloomGroupCertificate } from '../enums/embloomGroupCertificate';

export interface IServiceGroupSettingsEditValidated {
    embloomGroupCertificate: EmbloomGroupCertificate | null;
    endDate: string | null;
    isKetenDbc: boolean;
    noShowsImported: boolean;
    startDate: string;
    supervisionPercentage: number | null;
}

const serviceGroupSettingsEdit = Koi.object({
    embloomGroupCertificate: Koi.koi().enum(EmbloomGroupCertificate).allow(null),
    endDate: Koi.koi().endDate().allow(null),
    isKetenDbc: Koi.boolean(),
    noShowsImported: Koi.boolean(),
    startDate: Koi.koi().date(),
    supervisionPercentage: Koi.number().allow(null).min(0).max(100).integer(),
});

export const serviceGroupSettingsEditSchema: ISchemaContainer<IServiceGroupSettingsEditValidated> = {
    schema: serviceGroupSettingsEdit.options({ convert: false, presence: 'required' }),
};

export interface IServiceGroupSettingsAddValidated extends IServiceGroupSettingsEditValidated {
    groupId: string;
    serviceId: string;
}

export const serviceGroupSettingsAddSchema: ISchemaContainer<IServiceGroupSettingsAddValidated> = {
    schema: serviceGroupSettingsEdit
        .keys({
            groupId: Koi.string().uuid(),
            serviceId: Koi.string().uuid(),
        })
        .options({ convert: false, presence: 'required' }),
};
